import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import {
  ItemRestrictionsResponseUI,
  MerchantRestrictionsResponseUI,
} from 'src/types/OrderRestrictions';
import { useOrderRestrictions } from 'src/common/OrderRestrictions/OrderRestrictionsProvider/hooks/useOrderRestrictions';

export type OrderRestrictionsContextType = {
  isLoading: boolean;
  merchantRestrictionsMeta?: MerchantRestrictionsResponseUI[] | null;
  itemRestrictionsMeta?: ItemRestrictionsResponseUI[] | null;
  error?: Error | null;
};

const OrderRestrictionsContext =
  createContext<OrderRestrictionsContextType | null>(null);

interface OrderRestrictionsProviderProps {
  children: ReactNode;
}

export const OrderRestrictionsProvider: React.FC<OrderRestrictionsProviderProps> =
  ({ children }) => {
    const { getOrderRestrictionsList, isLoading, restrictions, error } =
      useOrderRestrictions();

    useEffect(() => {
      getOrderRestrictionsList();
    }, [getOrderRestrictionsList]);

    return (
      <OrderRestrictionsContext.Provider
        value={{
          isLoading,
          merchantRestrictionsMeta: restrictions?.merchantRestrictions,
          itemRestrictionsMeta: restrictions?.itemRestrictions,
          error,
        }}
      >
        {children}
      </OrderRestrictionsContext.Provider>
    );
  };

export function useOrderRestrictionContext(): OrderRestrictionsContextType {
  const context = useContext(OrderRestrictionsContext);
  if (context === null) {
    throw new Error(
      'useOrderRestrictions must be used within a OrderRestrictionsProvider'
    );
  }
  return context;
}
